import { render, staticRenderFns } from "./EventSearchCriteria.vue?vue&type=template&id=526ca8c0&scoped=true"
import script from "./EventSearchCriteria.vue?vue&type=script&lang=ts"
export * from "./EventSearchCriteria.vue?vue&type=script&lang=ts"
import style0 from "./EventSearchCriteria.vue?vue&type=style&index=0&id=526ca8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ca8c0",
  null
  
)

export default component.exports